module.exports = __webpack_public_path__ + "json/market9-0.json?6602dedada555b361f89a8d7a9bf33da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market9-0.json
// module id = 1270
// module chunks = 3